<button
  type="button"
  class="admin-toggle"
  role="switch"
  [class.admin-toggle--on]="checked()"
  [disabled]="disabled()"
  [attr.aria-checked]="checked()"
  [attr.aria-label]="ariaLabel()"
  (click)="toggle()"
>
  <span class="admin-toggle__track" aria-hidden="true">
    <span class="admin-toggle__thumb"></span>
  </span>
</button>
